import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import Button, { ILink } from '../Button';
export interface IVHSTipProps extends IBaseElementProps {
	/**
	 * Icon
	 */
	headingIcon?: 'fast-track' | 'search';
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Text
	 * @control richtext
	 */
	text?: string;
	/**
	 * CTA
	 */
	cta?: ILink;
	/**
	 * Footnote Icon
	 */
	footnoteIcon?: 'bulb' | 'search';
	/**
	 * Footnote
	 * @control richtext
	 */
	footnote?: string;
}

/**
 * Tip
 * @block
 * @icon lightbulb
 */
const VHSTip: React.FC<IVHSTipProps> = ({
	headingIcon,
	heading,
	text,
	cta,
	footnoteIcon,
	footnote,
	className,
	classNames = [],
}) => (
	<div className={className || cn('vhs-tip', ...classNames)}>
		<div className="vhs-tip__container">
			<div className="vhs-tip__wrapper">
				<div className="vhs-tip__heading-wrapper">
					{headingIcon && <i className={`vhs-tip__heading-icon icon icon-${headingIcon}`}></i>}
					{heading && <h2 className="vhs-tip__heading">{heading}</h2>}
				</div>
				<div className="vhs-tip__content">
					{text && <div className="vhs-tip__text" dangerouslySetInnerHTML={{ __html:text }}/>}
					{cta?.label && (
						<div className="vhs-tip__cta ">
							<Button
								{...cta}
								className="btn btn-sm btn-primary"
							/>
						</div>
					)}
				</div>
			</div>
			{footnote && (
				<div className="vhs-tip__footnote-wrapper">
					{footnoteIcon && (
						<div className="vhs-tip__footnote-icon-wrapper">
							<i className={`vhs-tip__footnote-icon icon icon-${footnoteIcon}`}></i>
						</div>
					)}
					<div className="vhs-tip__footnote" dangerouslySetInnerHTML={{ __html:footnote }}/>
				</div>
			)}
		</div>
	</div>
);
export default VHSTip;
